<template>
  <main role="main">
    <RouterView />
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppBareLayout'
})
</script>

<style scoped></style>
